import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from "@material-ui/core/Chip/Chip";

const useStyles = makeStyles({
    root: {
        position: 'relative',
        margin: '0 6px',
        width: '100%',
        marginBottom: 12
    },
    rootMobile: {
        position: 'relative',
        margin: '5px 10px 10px 6px',
        width: '100%',
    },
    chip: {
        borderRadius: 2,
        marginRight: 5,
        marginBottom: 1,
        maxWidth: 200
    },
    sideContent: {
        position: 'absolute',
        right: 0,
        bottom: 0
    },
    withSideContent: {
        marginRight: 182,
        ['@media (max-width:700px)']: {
            marginRight: 100,
        },
    }
});

export default function FilterSelection(props) {

    const classes = useStyles();
    const [counter, setCounter] = React.useState(0);

    const filter = props.filter;

    const handleDelete = (name) => {
        switch(name) {
            case 'priceRange':
                filter.dispatch();
                filter.dispatchFilter();
                filter.dispatchResetPriceRange();
                break;
            case 'make':
                filter.params.selectedMakes = {};
                filter.dispatchFilter();
                break;
            case 'model':
                for (let i in filter.params.selectedMakes) {
                    delete filter.params.selectedMakes[i]['models'];
                }
                filter.dispatchFilter();
                break;
            case 'trim':
                for (let i in filter.params.selectedMakes) {
                    if (filter.params.selectedMakes[i]['models']) {
                        for (let j in filter.params.selectedMakes[i]['models']) {
                            delete filter.params.selectedMakes[i]['models'][j]['trim'];
                        }
                    }
                }
                filter.dispatchFilter();
                break;
            case 'year':
                filter.params.minYear = null;
                filter.params.maxYear = null;
                filter.dispatchFilter();
                break;
            case 'location':
                filter.params.distance = 50;
                filter.params.zipCode = '';
                filter.dispatchFilter();
                break;
            case 'options':
                filter.params.options = null;
                filter.dispatchFilter();
                break;
        }
    };

    let maxPrice = null;
    let minPrice = null;

    let makes = [];
    let models = [];
    let trims = [];
    let minYear = null;
    let maxYear = null;
    let zipCode = null;
    let distance = null;
    let options = null;

    filter.params.filterOptions.map(option => {
        switch(option.name) {
            case 'minPrice':
                minPrice = option.value;
                break;
            case 'maxPrice':
                maxPrice = option.value;
                break;
            case 'make':
                makes.push(option.value);
                break;
            case 'model':
                models.push(option.value.split(';;').pop());
                break;
            case 'trim':
                const parts = option.value.split(';;');
                trims.push(parts[1]+' '+parts[2]);
                break;
            case 'minYear':
                minYear = option.value;
                break;
            case 'maxYear':
                maxYear = option.value;
                break;
            case 'zipCode':
                zipCode = option.value ? option.value.toString().replace(/[^0-9\-\ ]/g, '') : '';
                break;
            case 'distance':
                distance = parseInt(option.value);
                break;
            case 'options':
                if ({
                    'SUV': true,
                    'truck': true,
                    'sedan': true,
                    'coupe': true,
                    'convertible': true,
                    'wagon': true,
                    'minivan': true,
                    'hatchback': true,
                }[option.value]) {
                    options = option.value.charAt(0).toUpperCase() + option.value.slice(1);
                } else {
                    options = 'Custom search';
                }
                break;
        }
    });

    filter.addDispatchCallback('selection', () => {
        render();
    });

    const render = () => {
        setCounter(counter+1);
    };

    if (!filter.params.hasSelection) {
        return null;
    }

    return (<div className={props.isMobile ? classes.rootMobile : classes.root}>
        <div className={props.sideContent ? classes.withSideContent : null}>
            {minYear && maxYear?
                <Chip className={classes.chip} label={'Year: '+minYear+" to "+maxYear}
                      onDelete={() => handleDelete('year')} color="primary" />
                : null}
            {minYear && !maxYear?
                <Chip className={classes.chip} label={'Year: Min '+minYear}
                      onDelete={() => handleDelete('year')} color="primary" />
                : null}
            {!minYear && maxYear?
                <Chip className={classes.chip} label={'Year: Max '+maxYear}
                      onDelete={() => handleDelete('year')} color="primary" />
                : null}
            {makes.length ?
                <Chip className={classes.chip} label={'Make: '+makes.join(', ')}
                      onDelete={() => handleDelete('make')} color="primary" />
                : null}
            {models.length ?
                <Chip className={classes.chip} label={'Model: '+models.join(', ')}
                      onDelete={() => handleDelete('model')} color="primary" />
                : null}
            {trims.length ?
                <Chip className={classes.chip} label={'Trim: '+trims.join(', ')}
                      onDelete={() => handleDelete('trim')} color="primary" />
                : null}
            {minPrice || maxPrice ?
                <Chip className={classes.chip} label={"Price: $"
                +new Intl.NumberFormat().format(1000*Math.floor(minPrice/(100*1000)))
                +"—"+new Intl.NumberFormat().format(1000*Math.ceil(maxPrice/(100*1000)))}
                      onDelete={() => handleDelete('priceRange')} color="primary" />
                : null}

            {zipCode && distance ?
                <Chip className={classes.chip} label={"Within "+distance+" miles of "+zipCode}
                      onDelete={() => handleDelete('location')} color="primary" />
                : null}
            {options ?
                <Chip className={classes.chip} label={options}
                      onDelete={() => handleDelete('options')} color="primary" />
                : null}
        </div>
        {props.sideContent ? <div className={classes.sideContent}>{props.sideContent}</div> : null}
    </div>)
}